import { render, staticRenderFns } from "./VATReport.vue?vue&type=template&id=328497fa&"
import script from "./VATReport.vue?vue&type=script&lang=js&"
export * from "./VATReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports